<p-toast position="top-right" [baseZIndex]="11050"></p-toast>

<p-toast key="idle" position="top-right" styleClass="idle-toast">
  <ng-template pTemplate="message" let-message>
    <div class="flex items-start gap-2 custom-idle-toast">
      <i class="pi pi-clock mt-1"></i>

      <div>
        <div class="font-medium idle-title">Sessão inativa</div>

        <div *ngIf="(idle.countdown$ | async) as secs">
          Faltam {{ format(secs) }} para encerrar sua sessão por inatividade.
          Movimente o mouse ou tecle algo para manter conectado.
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<p-confirmDialog></p-confirmDialog>

<div class="min-h-screen flex flex-col overflow-x-hidden">
  <div class="flex-1 overflow-x-hidden">
    <router-outlet></router-outlet>
  </div>

  <app-mobile-float-menu
    *ngIf="showChrome && isMobile"
    [cartCount]="cartCount"
    [nomeComprador]="nomeComprador"
    [numeroCarteira]="numeroCarteiraSelecionada || 'Sem Carteira'"
    (toggleMenu)="toggleMenu()"
    (toggleFilters)="toggleFilters()"
    (toggleCart)="toggleCart()"
    (toggleAccount)="toggleAccount()"
    class="mobile-float-menu-global">
  </app-mobile-float-menu>

  <app-footer *ngIf="showChrome && !isMobile"></app-footer>
</div>